<mat-stepper linear #stepper class="stepper-container" (animationDone)="onStepAnimationDone()">
  <mat-step label="Preenchimento" [completed]="pdfViewBlob !== null" [editable]="!documentSent">
    <div class="step-content">
      <inscricoes-declaration [externalLoading]="externalLoading" (completed)="handleCompletedPreenchimento($event)" />
    </div>
    <div class="step-actions">
      <button mat-stroked-button color="warn" (click)="dialogRef.close()">Cancelar</button>
      <button
        mat-raised-button
        color="primary"
        (click)="declaration?.assinarDeclaracao()"
        [disabled]="!declaration?.declarationForm?.valid || externalLoading"
        id="btn-assinatura">
        <span *ngIf="!externalLoading">Revisar Declaração</span>
        <mat-spinner *ngIf="externalLoading" diameter="25"></mat-spinner>
      </button>
    </div>
  </mat-step>
  <mat-step label="Revisão e Assinatura" [completed]="documentSent" [editable]="!documentSent">
    <div class="step-content">
      <mat-card class="card-warning card-icon">
        <mat-icon>warning</mat-icon>
        Esta é uma prévia do documento. Para concluir o processo, é necessário assinar e enviar a declaração.
      </mat-card>
      <app-pdf-viewer *ngIf="pdfViewBlob !== null && !documentSent" [pdfBlob]="pdfViewBlob" />
    </div>
    <div class="step-actions">
      <button mat-stroked-button color="primary" matStepperPrevious>Voltar</button>
      <button
        mat-raised-button
        color="primary"
        (click)="sendDocument()"
        [disabled]="sendingDocument"
        id="btn-enviar-declaracao">
        <span *ngIf="!sendingDocument">Assinar e Enviar Declaração</span>
        <mat-spinner *ngIf="sendingDocument" diameter="25"></mat-spinner>
      </button>
    </div>
  </mat-step>
  <mat-step label="Confirmação" [completed]="documentSent" [editable]="false" [state]="documentSent ? 'done' : 'number'">
    <div class="step-content">
      <mat-card class="card-success card-icon">
        <mat-icon>check_circle</mat-icon>
        Declaração assinada e enviada com sucesso em {{ documentSentAt | date : 'dd/MM/yyyy' }} às {{ documentSentAt | date : 'HH:mm' }}.
      </mat-card>
      <iframe *ngIf="signedPdfUrl" [src]="signedPdfUrl" style="width:100%; flex:1; border:none; min-height:500px"></iframe>
    </div>
    <div class="step-actions">
      <button mat-stroked-button color="primary" (click)="downloadPdf()"><mat-icon>download</mat-icon> Baixar declaração</button>
      <button mat-raised-button color="primary" (click)="dialogRef.close()">Fechar</button>
    </div>
  </mat-step>
</mat-stepper>
